const CookieBanner = () => {
  const text =
    'Indem Sie diesen Hinweis schliessen oder mit dem Besuch der Seite fortfahren, akzeptieren Sie die Verwendung von Cookies. Weitere Informationen dazu finden Sie unter';

  return (
    <>
      <div
        className="cookiealert"
        role="alert"
        aria-label="Datenschutz und Cookies"
        aria-hidden="false"
      >
        <div className="container">
          <div className="row">
            <div className="col-9 col-sm-10 p-2">
              <p className="p-4">
                {text}{' '}
                <a
                  href="https://www.fhnw.ch/de/impressum/datenschutz"
                  target="_blank"
                >
                  Datenschutz
                </a>
                .
              </p>
            </div>
            <div className="col-3 col-sm-2">
              <button
                type="button"
                className="btn btn-secondary btn-sm acceptcookies float-right pl-3 pr-3"
                aria-label="Schliessen"
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookieBanner;
